import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { CircularProgress } from '@mui/material';

export default function Portal() {

  const [formState, setFormState] = useState({adminCode:"", loading:false});

  const load = () => {
    const newFormState = { ...formState, loading: true }
    setFormState(newFormState);
    fetch("api/Status", {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(res => res.json())
      .then(data => {
        console.log(JSON.stringify(data));
      });
  };

  useEffect(() => { load() }, []);


  if (formState.loading) {
    return (
      <div className="loading-container mb-5">
        <CircularProgress />
      </div>
    )
  }

  return (
    <Container>
      asdf
    </Container>
  );
}
